export interface IRecentPost {
  title: string;
  thumb: string;
  badge: string;
}

const data: IRecentPost[] = [
  {
    title: 'Progressively Extensive Infomediaries',
    thumb: '/assets/img/products/magdalena-thumb.jpg',
    badge: 'NEW'
  },
  {
    title: 'Assertively Iterate Resource Maximizing',
    thumb: '/assets/img/products/marble-cake-thumb.jpg',
    badge: ''
  },
  {
    title: 'Manufactured Products',
    thumb: '/assets/img/products/salzburger-nockerl-thumb.jpg',
    badge: 'TRENDING'
  },
  {
    title: 'Podcasting Operational Change',
    thumb: '/assets/img/products/goose-breast-thumb.jpg',
    badge: ''
  },
  {
    title: 'Performing a Deep Dive',
    thumb: '/assets/img/products/petit-gateau-thumb.jpg',
    badge: ''
  }
];

export default data;
